
import ResetButton from '@/components/buttons/ResetButton.vue';
import { isFilterActive } from '@/helpers/filter-helper';
import { OfferMonetizationType, OfferMonetizationTypes } from '@/interfaces/titles';
import { FilterCollection, FilterName } from '@/stores/filter.store';
import ToggleButton from '@/ui-components/ToggleButton.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CollectionType } from '../../enums/collection-type';

const Filter = namespace('filter');

@Component({
	name: 'FilterMonetizationTypes',
	components: { ResetButton, ToggleButton },
})
export default class FilterMonetizationTypes extends Vue {
	@Prop() collectionType: CollectionType;
	@Prop() currentFilters: FilterCollection;

	@Filter.Action toggle: (payload: { filterName: FilterName; value: any; selectedState: 1 | 0 }) => void;
	@Filter.Action resetFilter: (payload: { filterName: FilterName }) => void;

	get options() {
		// not all monetization options shoudl be shown, there are some
		// that should not be selected
		const options = OfferMonetizationTypes.filter(f => f.visible) // show only visible types
			.sort((a, b) => a.priority - b.priority); // order by priority ASC
		return options;
	}

	isFilterActive(filterName: FilterName, value: any) {
		return isFilterActive(filterName, value, this.currentFilters);
	}
	clicked(monetizationType: OfferMonetizationType) {
		const selectedState: 1 | 0 = this.isFilterActive('monetization_types', monetizationType) ? 0 : 1;
		this.toggle({ filterName: 'monetization_types', value: monetizationType, selectedState });
	}
}
